exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-demo{margin:10px}.cus-show{margin:10px 5px}.fa-fix{color:#fff;margin-left:10px}", ""]);

// exports
